import { getAccessJwtPayload } from '../../../utils/auth'
import { assistanceService } from '../../../services/Assistance'
import { googleMapService } from '../../../services/GoogleMap'
import { riderService } from '../../../services/Rider'
import { tripService } from '../../../services/Trip'
import {
  ActionsUnion,
  IActiveTripResponse,
  IActiveTripResponseV2,
  IPingDTO,
  IAssistanceObject,
  ICoordinates,
  IOperatorLocation,
  IPagination,
  IMap,
  IRiderSearchObject,
  ISimpleDriverDTO,
  ITripHistoryObject,
  ITripProductPricing,
  ITripAvailableProduct,
  ITripFilters,
  ITripEstimatesObject,
  ITripRequestObject,
  ITripStatus,
  ITripImportResults,
  IRecentTrips,
  IRiderTrip,
  IUserTrips,
  ITripState,
  IManualCompleteTripState,
  ITripEdit,
  IAvailabilityDTO,
  IDailyTripLogReq,
  ICountTripStatusFilter,
  ITripExtraParams,
  IServiceListFilterDTO,
  WeatherQueryParams,
  WeatherDTO,
  ITripPassengerDetail,
  SelectedAddOn,
  ITripLogReq,
  ITripSummaryFiltersDTO,
  ITripSummaryResponseDTO,
  IScheduledRequestedTripsFiltersDTO,
  IUpdateOptimizedTripsDTO,
  TemporaryVehicleDTO,
  GenerateRecurringTripsRequestDTO,
  TempVehicleCountByServiceResponseDTO,
  ITempVehicleTripsCountResponseDTO,
  ILocationStopV2,
  ISimpleProviderProduct,
  IUserTopPanelRider
} from '../../../types'
import { ICoordinatesWithShortKeyDTO } from '../../../types/google-map'
import history from '../../../history'
import { createAction } from '../helpers'
import * as constants from '../../constants'
import { getStageByStatus, TripStatuses } from '../../../constants/trip-statuses'
import { driversService } from '../../../services/Drivers'
import { actionCreators as mapsActionCreators } from '../google_map'
import { actionCreators as riderActionCreators } from '../riders'
import { actionCreators as riderLocationActionCreators } from '../rider-locations'
import * as moment from 'moment-timezone'
import { ITripGroupRides, ManualTripGroupRidesDTO } from 'src/types/trip-group-rides'

export type ITripAction = ActionsUnion<typeof actionCreators>
;(window as any).tripService = tripService

export const actionCreators = {
  //Sync action creators
  updateTripFilters: (filters: ITripFilters) => createAction(constants.UPDATE_TRIP_FILTERS, filters),
  updateTripSummaryFilters: (filters: ITripSummaryFiltersDTO) =>
    createAction(constants.UPDATE_TRIP_SUMMARY_FILTERS, filters),
  updateTripDriver: () => createAction(constants.UPDATE_TRIP_DRIVER),
  selectTripRows: (filters: ITripState) => createAction(constants.SELECT_TRIP_ROWS, filters),
  feedbackFilters: (filters: ITripFilters) => createAction(constants.FEEDBACK_FILTERS, filters),
  selectRider: (rider: IRiderSearchObject) => createAction(constants.SELECT_RIDER_FOR_TRIP, rider),
  selectOrg: (orgId: string) => createAction(constants.SELECT_ORG_FOR_TRIP, orgId),
  selectProduct: (product: ITripAvailableProduct) => createAction(constants.SELECT_PROVIDER_PRODUCT, { product }),
  setCurrentServiceId: (serviceId: string) => createAction(constants.SELECT_SERVICE_ID, serviceId),
  onClearAutoComplete: () => createAction(constants.CLEAR_AUTO_COMPLETE),
  setQuery: (query: string) => createAction(constants.SET_QUERY, query),
  clearLocationSearch: () => createAction(constants.CLEAR_LOCATION_SEARCH),
  tripsHistoryUpdateColumns: (columns: string[]) => createAction(constants.TRIPS_HISTORY_UPDATE_COLUMNS, columns),

  tripUpdateSuccess: (trip: IActiveTripResponseV2, stage: string) =>
    createAction(constants.UPDATE_TRIP_SUCCESS, { trip, stage }),

  updateTripInState: (trip: IActiveTripResponseV2) => {
    const tripStatus = trip.lastStatus
    const stage = getStageByStatus(tripStatus)
    return createAction(constants.UPDATE_TRIP_SUCCESS, { trip, stage })
  },

  setOriginToTripRequest: (location: any) => createAction(constants.SET_ORIGIN_TO_TRIP_REQUEST, location),
  setDestinationToTripRequest: (location: any) => createAction(constants.SET_DESTINATION_TO_TRIP_REQUEST, location),
  setAdditionalStopToTripRequest: (location: any) =>
    createAction(constants.SET_ADDITIONAL_STOP_TO_TRIP_REQUEST, location),
  changeAdditionalStopOrder: (payload: { draggedIndex: number; draggedOverIndex: number }) =>
    createAction(constants.CHANGE_ADDITIONAL_STOP_ORDER, payload),
  changeLocationsOrder: (payload: { draggedIndex: number; draggedOverIndex: number }) =>
    createAction(constants.CHANGE_LOCATIONS_ORDER, payload),
  removeAdditionalStopFromTripRequest: (location: any) =>
    createAction(constants.REMOVE_ADDITIONAL_STOP_FROM_TRIP_REQUEST, location),
  setEstimatesToTripRequest: (estimates: ITripEstimatesObject) =>
    createAction(constants.SET_ESTIMATES_TO_TRIP_REQUEST, estimates),
  setPickupToTripRequest: (pickupTime?: string) => createAction(constants.SET_PICKUP_TIME_TO_TRIP_REQUEST, pickupTime),
  setLeaveAtToTripRequest: (dateTime?: string) => createAction(constants.SET_LEAVE_AT_TIME_TO_TRIP_REQUEST, dateTime),
  setArriveByToTripRequest: (dateTime?: string) => createAction(constants.SET_ARRIVE_BY_TIME_TO_TRIP_REQUEST, dateTime),
  setDropoffToTripRequest: (dropoffTime?: string) =>
    createAction(constants.SET_DROPOFF_TIME_TO_TRIP_REQUEST, dropoffTime),
  setRecurringPickupTime: (recurPickupTime?: string) =>
    createAction(constants.SET_RECURRING_PICK_UP_TIME, recurPickupTime),
  setRecurringDropoffTime: (recurDropoffTime?: string) =>
    createAction(constants.SET_RECURRING_DROP_OFF_TIME, recurDropoffTime),

  setDistanceAndDurationToTripRequest: (param?: { distance?: number; duration?: number }) =>
    createAction(constants.SET_DISTANCE_AND_DURATION_TO_TRIP_REQUEST, param),

  cloneTrip: (trip: IRiderTrip) => createAction(constants.TRIP_CLONE, trip),
  setDropoffPhoneNumber: (phone: string) => createAction(constants.SET_DROPOFF_PHONE_NUMBER, phone),
  setPickupPhoneNumber: (phone: string) => createAction(constants.SET_PICKUP_PHONE_NUMBER, phone),
  swapLocations: () => createAction(constants.TRIP_LOCATION_SWAP),
  resetSelectedTripRequestProduct: () => createAction(constants.RESET_SELECTED_TRIP_REQUEST_PRODUCT),
  updateTripNotes: (notes: string) => createAction(constants.TRIP_NOTES_UPDATE, notes),
  updateTripConfirmationNumber: (confirmationNumber: string) =>
    createAction(constants.TRIP_CONFIRMATION_NUMBER_UPDATE, confirmationNumber),
  updateTripProviderOneNumber: (providerOneNumber: string) =>
    createAction(constants.TRIP_PROVIDER_ONE_NUMBER_UPDATE, providerOneNumber),
  updateTripRequester: (requesterName: string) => createAction(constants.TRIP_REQUESTER_NAME, requesterName),
  //Set PaymentMode
  updatePaymentMode: (paymentMode: string) => createAction(constants.TRIP_PAYMENTMODE_UPDATE, paymentMode),
  updateRiderCount: (count: number) => createAction(constants.RIDER_COUNT_UPDATE, count),
  showMembers: () => createAction(constants.TRIP_SHOW_MEMBERS),
  hideMembers: () => createAction(constants.TRIP_HIDE_SHOW_MEMBERS),
  setCronTabExpression: (cronTabExpression?: string) => createAction(constants.SET_CRON_TAB_EXP, cronTabExpression),
  setRunForever: (runForever?: boolean) => createAction(constants.SET_RUN_FOREVER, runForever),
  setTimesToRecur: (timeToRecur?: number) => createAction(constants.SET_TIMES_TO_RECUR, timeToRecur),
  setTripDoubleCheckerEnable: (enable: boolean) => createAction(constants.SET_TRIP_DOUBLE_CHECKER_ENABLE, enable),
  bookDoubleTrip: (book: boolean) => createAction(constants.SET_BOOK_DOUBLE_TRIP, book),

  //PASSENGERS
  setTripPassengerDetails: (passengerDetails: ITripPassengerDetail) =>
    createAction(constants.SET_TRIP_PASSENGER_DETAILS, passengerDetails),
  setTripRequestTotalRidersFare: (totalRidersFare: number) =>
    createAction(constants.SET_TRIP_REQUEST_TOTAL_RIDERS_FARE, totalRidersFare),

  //Async action creators
  getTripProductPricingRequest: () => createAction(constants.GET_TRIP_PRODUCT_PRICING_REQUEST),
  getTripProductPricingSuccess: (productPricing: IMap<ITripProductPricing>) =>
    createAction(constants.GET_TRIP_PRODUCT_PRICING_SUCCESS, productPricing),
  getTripProductPricingFailure: (error: string) => createAction(constants.GET_TRIP_PRODUCT_PRICING_FAIL, error),

  recentTripsRequest: () => createAction(constants.RECENT_TRIPS_REQUEST),
  recentTripsSuccess: (riderId: string, recentTrips: IRecentTrips) =>
    createAction(constants.RECENT_TRIPS_SUCCESS, { riderId, recentTrips }),
  recentTripsFailure: (error: string) => createAction(constants.RECENT_TRIPS_FAIL, error),

  userTripsRequest: () => createAction(constants.USER_TRIPS_REQUEST),
  userTripsSuccess: (userTrips: IUserTrips[]) => createAction(constants.USER_TRIPS_SUCCESS, userTrips),
  userTripsFailure: (error: string) => createAction(constants.USER_TRIPS_FAIL, error),

  searchPickupSuccess: (locations: ICoordinates) => createAction(constants.PICKUP_AUTO_COMPLETE, locations),
  searchDropoffSuccess: (locations: ICoordinates) => createAction(constants.DROPOFF_AUTO_COMPLETE, locations),
  searchAdditionalStopSuccess: (locations: ICoordinates) =>
    createAction(constants.ADDITIONAL_STOP_AUTO_COMPLETE, locations),

  searchLocationRequest: () => createAction(constants.SEARCH_LOCATION_REQUEST),
  searchLocationSuccess: (locations: ICoordinates) => createAction(constants.SEARCH_LOCATION_SUCCESS, locations),
  searchLocationFailure: (error: string) => createAction(constants.SEARCH_LOCATION_FAIL, error),

  selectLocationRequest: () => createAction(constants.SELECT_LOCATION_REQUEST),
  selectLocationSuccess: (locations: ICoordinates) => createAction(constants.SELECT_LOCATION_SUCCESS, locations),
  selectLocationFailure: (error: string) => createAction(constants.SELECT_LOCATION_FAIL, error),

  getActiveTripsRequest: () => createAction(constants.ACTIVE_TRIPS_REQUEST),
  getActiveTripsSuccess: (activeTrips: IActiveTripResponse[]) =>
    createAction(constants.ACTIVE_TRIPS_SUCCESS, activeTrips),
  getActiveTripsFailure: (error: string) => createAction(constants.ACTIVE_TRIPS_FAIL, error),

  getLastActiveTripsRequest: () => createAction(constants.LAST_ACTIVE_TRIPS_REQUEST),
  getLastActiveTripsSuccess: (activeTrips: IActiveTripResponseV2[]) =>
    createAction(constants.LAST_ACTIVE_TRIPS_SUCCESS, activeTrips),
  getLastActiveTripsFailure: (error: string) => createAction(constants.LAST_ACTIVE_TRIPS_FAIL, error),

  assistanceRequest: () => createAction(constants.ASSISTANCE_REQUEST),
  assistanceSuccess: (assistance: IAssistanceObject[]) => createAction(constants.ASSISTANCE_SUCCESS, assistance),
  assistanceFailure: (error: string) => createAction(constants.ASSISTANCE_FAIL, error),

  tripAvailableProductsRequest: () => createAction(constants.TRIP_AVAILABLE_PRODUCTS_REQUEST),
  tripAvailableProductsSuccess: (availableProducts: ITripAvailableProduct[]) =>
    createAction(constants.TRIP_AVAILABLE_PRODUCTS_SUCCESS, availableProducts),
  tripAvailableProductsFailure: (error: string) => createAction(constants.TRIP_AVAILABLE_PRODUCTS_FAILURE, error),

  tripCancelRequest: () => createAction(constants.TRIP_CANCEL_REQUEST),
  tripCancelSuccess: (tripId: string) => createAction(constants.TRIP_CANCEL_SUCCESS, tripId),
  tripCancelFailure: (error: string) => createAction(constants.TRIP_CANCEL_FAILURE, error),

  tripNoShowRequest: () => createAction(constants.TRIP_NO_SHOW_REQUEST),
  tripNoShowSuccess: (tripId: string) => createAction(constants.TRIP_NO_SHOW_SUCCESS, tripId),
  tripNoShowFailure: (error: string) => createAction(constants.TRIP_NO_SHOW_FAILURE, error),

  tripCreateRequest: (tripRequest: ITripRequestObject) => createAction(constants.TRIP_CREATE_REQUEST, tripRequest),
  tripCreateSuccess: (trip: IActiveTripResponse) => createAction(constants.TRIP_CREATE_SUCCESS, trip),
  tripCreateFailure: (error: string) => createAction(constants.TRIP_CREATE_FAILURE, error),

  intgerationFetchRequest: () => createAction(constants.INTEGRATION_FETCH_REQUEST),
  integrationFetchSuccess: (product: ITripAvailableProduct) =>
    createAction(constants.INTEGRATION_FETCH_SUCCESS, product),
  integrationFetchFailure: (error: string) => createAction(constants.INTEGRATION_FETCH_FAILURE, error),

  tripGetRequest: () => createAction(constants.TRIP_GET_REQUEST),
  tripGetSuccess: (trip: IActiveTripResponseV2) => createAction(constants.TRIP_GET_SUCCESS, trip),
  tripGetFailure: (error: string) => createAction(constants.TRIP_GET_FAILURE, error),

  getTripsHistoryRequest: () => createAction(constants.TRIPS_HISTORY_REQUEST),
  getTripsHistorySuccess: (trips: ITripHistoryObject) => createAction(constants.TRIPS_HISTORY_SUCCESS, trips),
  getTripsHistoryFailure: (error: string) => createAction(constants.TRIPS_HISTORY_FAILURE, error),

  getOrganiztionTripsRequest: () => createAction(constants.TRIPS_ORGANIZATION_REQUEST),
  getOrganiztionTripsSuccess: (trips: ITripHistoryObject) => createAction(constants.TRIPS_ORGANIZATION_SUCCESS, trips),
  getOrganiztionTripsFailure: (error: string) => createAction(constants.TRIPS_ORGANIZATION_FAILURE, error),

  getManyTripsRequest: () => createAction(constants.TRIPS_FETCH_REQUEST),
  getManyTripsSuccess: (trips: IActiveTripResponseV2[]) => createAction(constants.TRIPS_FETCH_SUCCESS, trips),
  getManyTripsFailure: (error: string) => createAction(constants.TRIPS_FETCH_FAILURE, error),

  getTripsSummaryRequest: () => createAction(constants.TRIPS_SUMMARY_REQUEST),
  getTripsSummarySuccess: (trips: ITripSummaryResponseDTO) => createAction(constants.TRIPS_SUMMARY_SUCCESS, trips),
  getTripsSummaryFailure: (error: string) => createAction(constants.TRIPS_SUMMARY_FAILURE, error),

  setTripsEmpty: () => createAction(constants.SET_TRIPS_EMPTY),

  generateRecurringTrips: () => createAction(constants.SET_TRIPS_EMPTY),

  getManyFeedbacksRequest: () => createAction(constants.FEEDBACK_FETCH_REQUEST),
  getManyFeedbacksSuccess: (trips: any) => createAction(constants.FEEDBACK_FETCH_SUCCESS, trips),
  getManyFeedbacksFailure: (error: string) => createAction(constants.FEEDBACK_FETCH_FAILURE, error),

  tripDriverLocationRequest: () => createAction(constants.TRIP_DRIVER_LOCATION_REQUEST),
  tripDriverLocationSuccess: (location: IOperatorLocation) =>
    createAction(constants.TRIP_DRIVER_LOCATION_SUCCESS, location),
  tripDriverLocationFailure: (error: string) => createAction(constants.TRIP_DRIVER_LOCATION_FAIL, error),

  filterTripsRequest: () => createAction(constants.ZONE_TRIPS_REQUEST),
  filterTripsSuccess: (activeTrips: IActiveTripResponseV2[]) => createAction(constants.ZONE_TRIPS_SUCCESS, activeTrips),
  filterTripsFailure: (error: string) => createAction(constants.ZONE_TRIPS_FAIL, error),

  assignOperatorRequest: () => createAction(constants.TRIP_ASSIGN_OPERATOR_REQUEST),
  assignOperatorSuccess: (trip: IActiveTripResponseV2) => createAction(constants.TRIP_ASSIGN_OPERATOR_SUCCESS, trip),
  assignOperatorFailure: (error: string) => createAction(constants.TRIP_ASSIGN_OPERATOR_FAIL, error),

  assignMultipleOperatorRequest: () => createAction(constants.TRIP_ASSIGN_MULTIPLE_OPERATOR_REQUEST),
  assignMultipleOperatorSuccess: (trip: IActiveTripResponseV2) =>
    createAction(constants.TRIP_ASSIGN_MULTIPLE_OPERATOR_SUCCESS, trip),
  assignMultipleOperatorFailure: (error: string) => createAction(constants.TRIP_ASSIGN_MULTIPLE_OPERATOR_FAIL, error),

  cancelMultipleOperatorRequest: () => createAction(constants.MULTIPLE_TRIP_CANCEL_OPERATOR_REQUEST),
  cancelMultipleOperatorSuccess: (trip: IActiveTripResponseV2) =>
    createAction(constants.MULTIPLE_TRIP_CANCEL_OPERATOR_SUCCESS, trip),
  cancelMultipleOperatorFailure: (error: string) => createAction(constants.MULTIPLE_TRIP_CANCEL_OPERATOR_FAIL, error),

  manualCompleteTripRequest: () => createAction(constants.MANUAL_COMPLETE_TRIP_REQUEST),
  manualCompleteTripSuccess: (trip: IActiveTripResponseV2) =>
    createAction(constants.MANUAL_COMPLETE_TRIP_SUCCESS, trip),
  manualCompleteTripFailure: (error: string) => createAction(constants.MANUAL_COMPLETE_TRIP_FAIL, error),

  completeTripManuallyRequest: () => createAction(constants.COMPLETE_TRIP_MANUALLY_REQUEST),
  completeTripManuallylSuccess: (tripId: string) => createAction(constants.COMPLETE_TRIP_MANUALLY_SUCCESS, tripId),
  completeTripManuallyFailure: (error: string) => createAction(constants.COMPLETE_TRIP_MANUALLY_FAILURE, error),

  cancelBillableManuallyRequest: () => createAction(constants.CANCEL_BILLABLE_MANUALLY_REQUEST),
  cancelBillableManuallylSuccess: (tripId: string) => createAction(constants.CANCEL_BILLABLE_MANUALLY_SUCCESS, tripId),
  cancelBillableManuallyFailure: (error: string) => createAction(constants.CANCEL_BILLABLE_MANUALLY_FAILURE, error),

  importTripsRequest: () => createAction(constants.IMPORT_TRIPS_REQUEST),
  importTripsSuccess: (results: ITripImportResults) => createAction(constants.IMPORT_TRIPS_SUCCESS, results),
  importTripsFailure: (error: string) => createAction(constants.IMPORT_TRIPS_FAIL, error),

  tripNotesPushNotifRequest: () => createAction(constants.TRIP_NOTES_PUSH_NOTIF_REQUEST),
  tripNotesPushNotifSuccess: (message: string) =>
    createAction(constants.TRIP_NOTES_PUSH_NOTIF_SUCCESS_MESSAGE, message),
  tripNotesPushNotifFail: (message: string) => createAction(constants.TRIP_NOTES_PUSH_NOTIF_FAIL, message),

  tripTimePushNotifRequest: () => createAction(constants.TRIP_TIME_PUSH_NOTIF_REQUEST),
  tripTimePushNotifSuccess: (message: string) => createAction(constants.TRIP_TIME_PUSH_NOTIF_SUCCESS_MESSAGE, message),
  tripTimePushNotifFail: (message: string) => createAction(constants.TRIP_TIME_PUSH_NOTIF_FAIL, message),

  tripOperatorPushNotifRequest: () => createAction(constants.TRIP_OPERATOR_PUSH_NOTIF_REQUEST),
  tripOperatorPushNotifSuccess: (message: string) =>
    createAction(constants.TRIP_OPERATOR_PUSH_NOTIF_SUCCESS_MESSAGE, message),
  tripOperatorPushNotifFail: (message: string) => createAction(constants.TRIP_OPERATOR_PUSH_NOTIF_FAIL, message),

  allottedTimePushNotifRequest: () => createAction(constants.ALLOTTED_TIME_PUSH_NOTIF_REQUEST),
  allottedTimePushNotifSuccess: (message: string) =>
    createAction(constants.ALLOTTED_TIME_PUSH_NOTIF_SUCCESS_MESSAGE, message),
  allottedTimePushNotifFail: (message: string) => createAction(constants.ALLOTTED_TIME_PUSH_NOTIF_FAIL, message),

  tripCancelPushNotifRequest: () => createAction(constants.TRIP_CANCEL_PUSH_NOTIF_REQUEST),
  tripCancelPushNotifSuccess: (message: string) =>
    createAction(constants.TRIP_CANCEL_PUSH_NOTIF_SUCCESS_MESSAGE, message),
  tripCancelPushNotifFail: (message: string) => createAction(constants.TRIP_CANCEL_PUSH_NOTIF_FAIL, message),

  saveDataRequest: () => createAction(constants.SAVE_DATA_REQUEST),
  saveDataSuccess: () => createAction(constants.SAVE_DATA_SUCCESS),
  saveDataFailure: (error: string) => createAction(constants.SAVE_DATA_FAILURE, error),

  savePolylineBoundsRequest: () => createAction(constants.SAVE_POLYLINE_BOUNDS_REQUEST),
  savePolylineBoundsSuccess: () => createAction(constants.SAVE_POLYLINE_BOUNDS_SUCCESS),
  savePolylineBoundsFailure: (error: string) => createAction(constants.SAVE_POLYLINE_BOUNDS_FAILURE, error),

  getDailyTripLogRequest: () => createAction(constants.GET_DAILY_TRIP_LOG_REQUEST),
  getDailyTripLogSuccess: (logs: any) => createAction(constants.GET_DAILY_TRIP_LOG_SUCCESS, logs),
  getDailyTripLogFailire: (error: string) => createAction(constants.GET_DAILY_TRIP_LOG_FAILURE, error),

  getTripLogPerServiceAndDateRangeRequest: () =>
    createAction(constants.GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_REQUEST),
  getTripLogPerServiceAndDateRangeSuccess: (logs: any) =>
    createAction(constants.GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_SUCCESS, logs),
  getTripLogPerServiceAndDateRangeFailure: (error: string) =>
    createAction(constants.GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_FAILURE, error),

  getTotalTripsPerServiceRequest: () => createAction(constants.GET_TOTAL_TRIPS_PER_SERVICE_REQUEST),
  getTotalTripsPerServiceSuccess: (logs: any) => createAction(constants.GET_TOTAL_TRIPS_PER_SERVICE_SUCCESS, logs),
  getTotalTripsPerServiceFailure: (error: string) => createAction(constants.GET_TOTAL_TRIPS_PER_SERVICE_FAILURE, error),

  getTripStatusesCountRequest: () => createAction(constants.GET_TRIPS_STATUS_COUNT_REQUEST),
  getTripStatusesCountSuccess: (resp: any) => createAction(constants.GET_TRIPS_STATUS_COUNT_SUCCESS, resp),
  getTripStatusesCountFailure: (error: any) => createAction(constants.GET_TRIPS_STATUS_COUNT_FAILURE, error),

  getUberOperatorNumberRequest: () => createAction(constants.GET_UBER_DRIVER_NUMBER_REQUEST),
  getUberOperatorNumberSuccess: (phoneNumber: string) =>
    createAction(constants.GET_UBER_DRIVER_NUMBER_SUCCESS, phoneNumber),
  getUberOperatorNumberFailure: (error: string) => createAction(constants.GET_UBER_DRIVER_NUMBER_FAILURE, error),

  setCurrentTrip: (tripId: string) => createAction(constants.SET_CURRENT_TRIP, tripId),
  setTripReqDetails: (payload: any) => createAction(constants.TRIP_REQ_DETAILS_UPDATE, payload),
  //Weather
  getWeatherUpdatesRequest: (payload: WeatherQueryParams) => createAction(constants.TRIP_WEATHER_UPDATES_REQUEST),
  getWeatherUpdatesSuccess: (dto: WeatherDTO) => createAction(constants.TRIP_WEATHER_UPDATES_SUCCESS, dto),
  getWeatherUpdatesFail: (dto: WeatherDTO) => createAction(constants.TRIP_WEATHER_UPDATES_FAIL, dto),

  updateFeedbackStatusRequest: () => createAction(constants.FEEDBACK_STATUS_UPDATE_REQUEST),
  updateFeedbackStatusSuccess: (response: any) => createAction(constants.FEEDBACK_STATUS_UPDATE_SUCCESS, response),
  updateFeedbackStatusFailure: (error: any) => createAction(constants.FEEDBACK_STATUS_UPDATE_FAILURE, error),

  routeOptimizeRequest: () => createAction(constants.ROUTE_OPTIMIZATION_REQUEST),
  routeOptimizeSuccess: (response: any) => createAction(constants.ROUTE_OPTIMIZATION_SUCCESS, response),
  routeOptimizeFailure: (error: any) => createAction(constants.ROUTE_OPTIMIZATION_FAILURE, error),

  optimizeTripRequest: () => createAction(constants.OPTIMIZE_TRIP_REQUEST),
  optimizeTripSuccess: (response: any) => createAction(constants.OPTIMIZE_TRIP_SUCCESS, response),
  optimizeTripFailure: (error: any) => createAction(constants.OPTIMIZE_TRIP_FAILURE, error),

  groupRequestedScheduledTripsRequest: () => createAction(constants.GROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST),
  groupRequestedScheduledTripsSuccess: (response: any) =>
    createAction(constants.GROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE, response),
  groupRequestedScheduledTripsFailure: (error: any) =>
    createAction(constants.GROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE, error),

  manualGroupTripsRequest: () => createAction(constants.MANUAL_GROUP_TRIPS_REQUEST),
  manualGroupTripsSuccess: (response: any) => createAction(constants.MANUAL_GROUP_TRIPS_SUCCESS, response),
  manualGroupTripsFailure: (error: any) => createAction(constants.MANUAL_GROUP_TRIPS_FAILURE, error),

  unGroupRequestedScheduledTripsRequest: () => createAction(constants.UNGROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST),
  unGroupRequestedScheduledTripsSuccess: (response: any) =>
    createAction(constants.UNGROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE, response),
  unGroupRequestedScheduledTripsFailure: (error: any) =>
    createAction(constants.UNGROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE, error),

  getTemporaryVehiclesRequest: () => createAction(constants.GET_TEMPORARY_VEHICLES_REQUEST),
  getTemporaryVehiclesSuccess: (response: TemporaryVehicleDTO[]) =>
    createAction(constants.GET_TEMPORARY_VEHICLES_SUCCESS, response),
  getTemporaryVehiclesFailure: (error: string) => createAction(constants.GET_TEMPORARY_VEHICLES_FAILURE, error),

  getTempVehicleTripsCountRequest: () => createAction(constants.GET_TEMP_VEHICLE_TRIPS_COUNT_REQUEST),
  getTempVehicleTripsCountSuccess: (response: ITempVehicleTripsCountResponseDTO) =>
    createAction(constants.GET_TEMP_VEHICLE_TRIPS_COUNT_SUCCESS, response),
  getTempVehicleTripsCountFailure: (error: any) => createAction(constants.GET_TEMP_VEHICLE_TRIPS_COUNT_FAILURE, error),

  getScheduledRequestedTripsRequest: () => createAction(constants.GET_SCHEDULED_REQUESTED_TRIPS_REQUEST),
  getScheduledRequestedTripsSuccess: (response: any) =>
    createAction(constants.GET_SCHEDULED_REQUESTED_TRIPS_SUCCESS, response),
  getScheduledRequestedTripsFailure: (error: any) =>
    createAction(constants.GET_SCHEDULED_REQUESTED_TRIPS_FAILURE, error),

  getTempVehicleByServiceCountRequest: () => createAction(constants.GET_TEMPVEHICLES_PER_SERVICE_REQUEST),
  getTempVehicleByServiceCountSuccess: (response: TempVehicleCountByServiceResponseDTO) =>
    createAction(constants.GET_TEMPVEHICLES_PER_SERVICE_SUCCESS, response),
  getTempVehicleByServiceCountFailure: (error: string) =>
    createAction(constants.GET_TEMPVEHICLES_PER_SERVICE_FAILURE, error),

  createTripErrorMessage: (message: string) => createAction(constants.CREATE_TRIP_FAIL, message),

  driverPushNotificationSuccess: (message: string) =>
    createAction(constants.DRIVER_PUSH_NOTIFICATION_SUCCESS_MESSAGE, message),
  driverPushNotificationFailure: (message: string) => createAction(constants.DRIVER_PUSH_NOTIFICATION_FAIL, message),
  createTripWithPcaRiderSuccess: (message: string) =>
    createAction(constants.TRIP_CREATED_WITH_PCA_RIDER_SUCCESS_MESSAGE, message)
}

export const importTrips = (orgId: string, awsData: { Location: string; Key: string; Bucket: string }) => {
  const { importTripsRequest, importTripsSuccess, importTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(importTripsRequest())
    return tripService.importTrips(orgId, awsData).then(
      res => {
        dispatch(importTripsSuccess(res.data))
        return res.data
      },
      err => {
        dispatch(importTripsFailure(err.data))
        return err
      }
    )
  }
}

// export const calculateProviderProductPricing = (request: any, product: any) => (dispatch: any) => {
//   const { getTripProductPricingRequest, getTripProductPricingSuccess, getTripProductPricingFailure } = actionCreators
//   dispatch(getTripProductPricingRequest())
//   tripService
//     .calculateProviderProductPricing(request, product)
//     .then(data => dispatch(getTripProductPricingSuccess(data)), err => dispatch(getTripProductPricingFailure(err)))
// }

export function selectRider(rider: IRiderSearchObject): any {
  const { selectRider } = actionCreators
  return (dispatch: any): any => {
    dispatch(riderActionCreators.ridersClearSearch())
    dispatch(selectRider(rider))
  }
}

export function recentTripsFetch(riderId: string, orgId: string) {
  const { recentTripsRequest, recentTripsSuccess, recentTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(recentTripsRequest())
    tripService
      .fetchRecentTrips(riderId, orgId)
      .then(
        (recentTrips: IRecentTrips) => dispatch(recentTripsSuccess(riderId, recentTrips)),
        (error: string) => dispatch(recentTripsFailure(error))
      )
  }
}

export function userTripsFetch(userId: string) {
  const { userTripsRequest, userTripsSuccess, userTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(userTripsRequest())
    tripService
      .fetchUserTrips(userId)
      .then(
        (userTrips: IUserTrips[]) => dispatch(userTripsSuccess(userTrips)),
        (error: string) => dispatch(userTripsFailure(error))
      )
  }
}

export const searchPickup = (value: string, bounds: string[]) => (dispatch: any) => {
  const { setQuery, searchLocationRequest, searchPickupSuccess, searchLocationFailure } = actionCreators
  dispatch(setQuery(value))
  dispatch(riderLocationActionCreators.setRiderLocationQuery(value))
  const callback = (error: string | null, data: any) => {
    if (error) {
      return dispatch(searchLocationFailure(error))
    }
    return dispatch(searchPickupSuccess(data))
  }
  return searchLocation(value, bounds, callback)
}

export const searchDropoff = (value: string, bounds: string[]) => (dispatch: any) => {
  const { setQuery, searchLocationRequest, searchDropoffSuccess, searchLocationFailure } = actionCreators
  dispatch(setQuery(value))
  const callback = (error: string | null, data: any) => {
    if (error) {
      return dispatch(searchLocationFailure(error))
    }
    return dispatch(searchDropoffSuccess(data))
  }
  return searchLocation(value, bounds, callback)
}

export const searchAdditionalStop = (value: string, index: number, bounds: string[]) => (dispatch: any) => {
  const { setQuery, searchAdditionalStopSuccess, searchLocationFailure } = actionCreators
  dispatch(setQuery(value))
  const callback = (error: string | null, data: any) => {
    if (error) {
      return dispatch(searchLocationFailure(error))
    }
    return dispatch(searchAdditionalStopSuccess(data))
  }
  return searchLocation(value, bounds, callback)
}

function searchLocation(value: string, bounds: string[], callback: (error: any, data?: any) => void): any {
  googleMapService
    .getPlacePredictions({
      input: value,
      bounds: new google.maps.LatLngBounds(
        new google.maps.LatLng(Number(bounds[0]), Number(bounds[2])),
        new google.maps.LatLng(Number(bounds[1]), Number(bounds[3]))
      )
    })
    .then(
      (googleLocations: any) => {
        const data = googleLocations.map((location: any) => ({
          googlePlaceId: location.place_id,
          location: {
            pickUpFullAddress: location.description
          }
        }))
        return callback(null, data)
      },
      (error: string) => callback(error)
    )
}

//TODO this is kinda hinky, need to make sure it works right
export function selectLocation(loc: any, locationType: string): any {
  const {
    setOriginToTripRequest,
    setDestinationToTripRequest,
    selectLocationRequest,
    searchLocationSuccess,
    selectLocationFailure,
    onClearAutoComplete,
    setAdditionalStopToTripRequest,
    removeAdditionalStopFromTripRequest
  } = actionCreators
  return (dispatch: any, value: string): any => {
    dispatch(onClearAutoComplete())
    dispatch(selectLocationRequest())
    if (locationType === constants.REMOVE_ADDITIONAL_STOP_FROM_TRIP_REQUEST) {
      dispatch(mapsActionCreators.removeAdditionalStop(loc))
      dispatch(mapsActionCreators.removeMarkers(loc))
      dispatch(removeAdditionalStopFromTripRequest(loc))
    } else {
      if (!loc.location) {
        const data = {
          formatted_address: loc.fullAddress,
          lat: loc.coordinates.lat,
          lng: loc.coordinates.lng,
          notes: loc.note,
          placeName: loc.placeName,
          phoneNumber: loc.phoneNumber
        }
        if (locationType === constants.SET_ORIGIN_TO_TRIP_REQUEST) {
          dispatch(mapsActionCreators.setOrigin(data))
          dispatch(mapsActionCreators.replaceMarkers('origin', [{ type: 'origin', lat: data.lat, lng: data.lng }]))
          dispatch(setOriginToTripRequest(data))
        }
        if (locationType === constants.SET_DESTINATION_TO_TRIP_REQUEST) {
          dispatch(mapsActionCreators.setDestination(data))
          dispatch(
            mapsActionCreators.replaceMarkers('destination', [{ type: 'destination', lat: data.lat, lng: data.lng }])
          )
          dispatch(setDestinationToTripRequest(data))
        }
        if (locationType === constants.SET_ADDITIONAL_STOP_TO_TRIP_REQUEST) {
          const dataWithIndex = {
            ...data,
            index: loc.index
          }
          dispatch(mapsActionCreators.setAdditionalStop(dataWithIndex))
          dispatch(
            mapsActionCreators.replaceMarkers('additionalStop', [
              { type: 'additionalStop', lat: data.lat, lng: data.lng, index: loc.index }
            ])
          )
          dispatch(setAdditionalStopToTripRequest(dataWithIndex))
        }
        dispatch(searchLocationSuccess(data))
      } else if (!loc.location.pickUpCoord) {
        googleMapService.getPlaceDetails(loc.googlePlaceId).then(
          (data: any) => {
            const locData = {
              formatted_address: loc.location.pickUpFullAddress,
              lat: data.geometry.location.lat(),
              lng: data.geometry.location.lng(),
              placeName: data.name
            }
            if (locationType === constants.SET_ORIGIN_TO_TRIP_REQUEST) {
              dispatch(mapsActionCreators.setOrigin(locData))
              dispatch(
                mapsActionCreators.replaceMarkers('origin', [{ type: 'origin', lat: locData.lat, lng: locData.lng }])
              )
              dispatch(setOriginToTripRequest(locData))
            }
            if (locationType === constants.SET_DESTINATION_TO_TRIP_REQUEST) {
              dispatch(mapsActionCreators.setDestination(locData))
              dispatch(
                mapsActionCreators.replaceMarkers('destination', [
                  { type: 'destination', lat: locData.lat, lng: locData.lng }
                ])
              )
              dispatch(setDestinationToTripRequest(locData))
            }
            if (locationType === constants.SET_ADDITIONAL_STOP_TO_TRIP_REQUEST) {
              const locDataWithIndex = {
                ...locData,
                index: loc.index
              }
              console.log(locDataWithIndex)
              dispatch(mapsActionCreators.setAdditionalStop(locDataWithIndex))
              dispatch(
                mapsActionCreators.replaceMarkers('additionalStop', [
                  { type: 'additionalStop', lat: locData.lat, lng: locData.lng, index: loc.index }
                ])
              )
              dispatch(setAdditionalStopToTripRequest(locDataWithIndex))
            }
            dispatch(searchLocationSuccess(locData))
          },
          (error: string) => dispatch(selectLocationFailure(error))
        )
      } else {
        dispatch(searchLocationSuccess(loc.location.pickUpCoord))
      }
    }
  }
}

//perhaps move it to map actions?
export function selectPinLocation(location: ICoordinatesWithShortKeyDTO, locationType: string): any {
  const {
    setOriginToTripRequest,
    setDestinationToTripRequest,
    selectLocationRequest,
    searchLocationSuccess,
    selectLocationFailure
  } = actionCreators
  return (dispatch: any, value: string): any => {
    dispatch(selectLocationRequest())
    googleMapService.reverseGeocode(location).then(
      (data: any) => {
        if (locationType === constants.SET_ORIGIN_TO_TRIP_REQUEST) {
          dispatch(
            mapsActionCreators.setOrigin({
              lat: location.lat,
              lng: location.lng,
              formatted_address: data.formatted_address
            })
          )
          dispatch(mapsActionCreators.replaceMarkers('origin', [{ type: 'origin', lat: location.lat, lng: data.lng }]))
          dispatch(
            setOriginToTripRequest({
              lat: location.lat,
              lng: location.lng,
              formatted_address: data.formatted_address
            })
          )
        }
        if (locationType === constants.SET_DESTINATION_TO_TRIP_REQUEST) {
          dispatch(
            mapsActionCreators.setDestination({
              lat: location.lat,
              lng: location.lng,
              formatted_address: data.formatted_address
            })
          )
          dispatch(
            mapsActionCreators.replaceMarkers('destination', [
              { type: 'destination', lat: location.lat, lng: location.lng }
            ])
          )
          dispatch(
            setDestinationToTripRequest({
              lat: location.lat,
              lng: location.lng,
              formatted_address: data.formatted_address
            })
          )
        }
        dispatch(searchLocationSuccess(data))
      },
      (error: string) => dispatch(selectLocationFailure(error))
    )
  }
}

export function getAssistance() {
  const { assistanceRequest, assistanceSuccess, assistanceFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(assistanceRequest)
    assistanceService
      .fetchAssistances()
      .then((data: any) => dispatch(assistanceSuccess(data)), ({ data }) => dispatch(assistanceFailure(data)))
  }
}

export function getActiveTrips(organizationId: string, stage: string, numberOfRecords: number) {
  const { getActiveTripsRequest, getActiveTripsSuccess, getActiveTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getActiveTripsRequest())
    tripService
      .fetchActiveTrips(organizationId, stage, numberOfRecords)
      .then(
        activeTrips => dispatch(getActiveTripsSuccess(activeTrips)),
        error => dispatch(getActiveTripsFailure(error))
      )
  }
}

export function getLastActiveTrips(filters: ITripFilters, pagination?: IPagination) {
  const { getLastActiveTripsRequest, getLastActiveTripsSuccess, getLastActiveTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getLastActiveTripsRequest())
    return tripService.fetchLastActiveTrips(filters, pagination).then(
      result => {
        dispatch(getLastActiveTripsSuccess(result.items))
        return result.total
      },
      error => dispatch(getLastActiveTripsFailure(error))
    )
  }
}

export const tripAvailableProducts = (riderId: string, tripInfo: any) => (dispatch: any) => {
  const {
    tripAvailableProductsRequest,
    tripAvailableProductsSuccess,
    tripAvailableProductsFailure,
    resetSelectedTripRequestProduct
  } = actionCreators
  dispatch(resetSelectedTripRequestProduct())
  dispatch(tripAvailableProductsRequest())
  return riderService
    .availableProducts(riderId, tripInfo)
    .then(
      (availableProducts: ITripAvailableProduct[]) => dispatch(tripAvailableProductsSuccess(availableProducts)),
      ({ data }) => dispatch(tripAvailableProductsFailure(data))
    )
}

export function getTripsHistory(orgId: string) {
  const { getTripsHistoryRequest, getTripsHistorySuccess, getTripsHistoryFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getTripsHistoryRequest())
    tripService.fetchTripsHistory(orgId).then(
      (tripsHistory: any) => {
        return dispatch(getTripsHistorySuccess(tripsHistory))
      },
      error => dispatch(getTripsHistoryFailure(error))
    )
  }
}

export function getOrganizationTrips(organizationId: string, pagination?: IPagination) {
  const { getOrganiztionTripsRequest, getOrganiztionTripsSuccess, getOrganiztionTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getOrganiztionTripsRequest())
    return tripService.fetchOrganizationTrips(organizationId, pagination).then(
      (tripsHistory: any) => {
        dispatch(getOrganiztionTripsSuccess(tripsHistory))
        return tripsHistory
      },
      error => dispatch(getOrganiztionTripsFailure(error))
    )
  }
}

export function getTripDetails(tripId: string) {
  return tripService.get(tripId).then(resp => resp, error => console.error('Error fetching trip details: ', error))
}

export function getSchedulerTrips(params: ITripFilters) {
  const { getManyTripsRequest, getManyTripsSuccess, getManyTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getManyTripsRequest())
    return tripService.fetch(params).then(
      async resp => {
        dispatch(getManyTripsSuccess(resp.items))
        return resp
      },
      (res: any) => {
        dispatch(getManyTripsFailure(res.data))
        setTimeout(() => {
          dispatch(getManyTripsFailure(''))
        }, 5000)
      }
    )
  }
}

export function updateSingleTrip(trip: IActiveTripResponseV2) {
  const { tripGetSuccess } = actionCreators
  return (dispatch: any) => {
    return dispatch(tripGetSuccess(trip))
  }
}

export function getManyTrips(params: ITripFilters) {
  const { getManyTripsRequest, getManyTripsSuccess, getManyTripsFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getManyTripsRequest())
    return tripService.fetch(params).then(
      resp => {
        dispatch(getManyTripsSuccess(resp.items))
        return resp
      },
      (res: any) => {
        dispatch(getManyTripsFailure(res.data))
        setTimeout(() => {
          dispatch(getManyTripsFailure(''))
        }, 5000)
      }
    )
  }
}

export function getTripsSummary(params: ITripSummaryFiltersDTO) {
  const { getTripsSummaryRequest, getTripsSummarySuccess, getTripsSummaryFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getTripsSummaryRequest())
    return tripService.fetchSummary(params).then(
      resp => {
        dispatch(getTripsSummarySuccess(resp))
        return resp
      },
      (res: any) => {
        dispatch(getTripsSummaryFailure(res.data))
        setTimeout(() => {
          dispatch(getTripsSummaryFailure(''))
        }, 5000)
      }
    )
  }
}

export function generateRecurringTrips(payload: GenerateRecurringTripsRequestDTO) {
  const { generateRecurringTrips } = actionCreators

  return (dispatch: any) => {
    dispatch(generateRecurringTrips())
    return tripService
      .generateRecurringTrips(payload)
      .then(resp => {
        return resp.data.message
      })
      .catch(e => {
        console.log(e)
        return e.statusText
      })
  }
}

export function getManyFeedbacks(params: any) {
  const { getManyFeedbacksRequest, getManyFeedbacksSuccess, getManyFeedbacksFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getManyFeedbacksRequest())
    return tripService.fetchFeedback(params).then(
      resp => {
        dispatch(getManyFeedbacksSuccess(resp.items))
        return resp
      },
      (res: any) => {
        dispatch(getManyFeedbacksFailure(res.data))
        setTimeout(() => {
          dispatch(getManyFeedbacksFailure(''))
        }, 5000)
      }
    )
  }
}
export const fetchIntegrationEta = (riderId: string, product: ITripAvailableProduct, selectedAddOn?: SelectedAddOn) => (
  dispatch: any,
  getState: any
) => {
  const {
    intgerationFetchRequest,
    integrationFetchSuccess,
    integrationFetchFailure,
    setDistanceAndDurationToTripRequest
  } = actionCreators
  const tripRequest = getState().tripRequest.request
  const additionalStops = tripRequest.additionalStop.map((loc: any) => ({
    address: loc.fullAddress,
    lat: loc.latitude,
    lng: loc.longitude
  }))

  // Get user's time zone
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  const originSource: IAvailabilityDTO = {
    origin: {
      address: tripRequest.pickupLocation.fullAddress,
      lat: tripRequest.pickupLocation.latitude,
      lng: tripRequest.pickupLocation.longitude
    },
    destination: {
      address: tripRequest.dropoffLocation.fullAddress,
      lat: tripRequest.dropoffLocation.latitude,
      lng: tripRequest.dropoffLocation.longitude
    },
    additionalStops,
    scheduledPickupTime: tripRequest.scheduledPickupTime,
    addOn: selectedAddOn,
    timezone
  }
  dispatch(intgerationFetchRequest())
  return tripService
    .fetchIntegrationProduct(riderId, {
      product: { ...product, productName: product.name, productId: product.id },
      tripRequest: originSource
    })
    .then(resp => {
      dispatch(integrationFetchSuccess(resp.data))
      dispatch(setDistanceAndDurationToTripRequest({ distance: resp.data.distance, duration: resp.data.duration }))
      return resp.data
    })
    .catch(err => dispatch(integrationFetchFailure(err)))
}

export const createTrip = (params?: ITripExtraParams) => async (dispatch: any, getState: any) => {
  const {
    tripCreateRequest,
    tripCreateSuccess,
    tripCreateFailure,
    bookDoubleTrip,
    createTripWithPcaRiderSuccess
  } = actionCreators
  const tripRequest = getState().tripRequest.request

  const riderDetails: IUserTopPanelRider = await riderService.getRiderPersonalInfo(tripRequest.rider.riderId)

  if (!tripRequest.rider.phoneNumber) {
    tripRequest.rider = {
      birthDate: riderDetails.birthDate,
      email: riderDetails.email,
      firstName: riderDetails.firstName,
      lastName: riderDetails.lastName,
      riderId: riderDetails.id,
      phoneNumber: riderDetails.phones[0].phoneNumber,
      countryCode: riderDetails.phones[0].countryCode
    }
  }

  const apiFunc =
    tripRequest.lastStatus === TripStatuses.DISPATCH_ASSIGNED_DRIVER
      ? tripService.assignedDispatchTrip
      : tripRequest.scheduledPickupTime ||
        tripRequest.scheduledDropoffTime ||
        tripRequest.leaveAtDateTime ||
        tripRequest.arriveByDateTime
      ? tripService.schedule
      : tripService.create

  const funcName =
    tripRequest.lastStatus === TripStatuses.DISPATCH_ASSIGNED_DRIVER
      ? 'assignedDispatchTrip'
      : tripRequest.scheduledPickupTime ||
        tripRequest.scheduledDropoffTime ||
        tripRequest.leaveAtDateTime ||
        tripRequest.arriveByDateTime
      ? 'schedule'
      : 'create'
  tripRequest.routePolyline = getState().mapView.polyline
  tripRequest.bounds = getState().mapView.bounds
  tripRequest.tripType = 'app'
  tripRequest.rider.countryCode = tripRequest.rider.countryCode.length > 0 ? tripRequest.rider.countryCode : '+1'
  tripRequest.rider.phoneNumber = tripRequest.rider.phoneNumber.startsWith('1')
    ? tripRequest.rider.phoneNumber.slice(1)
    : tripRequest.rider.phoneNumber
  tripRequest.riderCount = tripRequest.passengerDetails.tripRequestRiders.reduce(
    (partial: number, c: ITripGroupRides) => partial + c.totalRider,
    0
  )
  tripRequest.distance = tripRequest.distance ? Number(tripRequest.distance) : 0
  tripRequest.duration = tripRequest.duration ? Number(tripRequest.duration) : 0
  if (Array.isArray(tripRequest.additionalStop) && tripRequest.additionalStop.length > 0) {
    const destinations = tripRequest.additionalStop.map((stop: ILocationStopV2, index: number) => {
      const destination: ILocationStopV2 = {
        ...stop,
        sequenceNo: index
      }

      return destination
    })
    tripRequest.destinations = {
      items: destinations
    }
  } else {
    tripRequest.destinations = {
      items: []
    }
  }

  if (params) {
    tripRequest.estimates = { ...tripRequest.estimates, price: params.addOnCost, fare: params.addOnFare }
    tripRequest.addOn = params.addOn
    // tripRequest.willCall = true
  }

  const { scheduledReturn = false, returnPickupTime = '' } = params || {}

  // Check if scheduled return ride is enabled
  if (scheduledReturn) {
    // Set isReturnedTrip to true for scheduled trips, false for on-demand trips
    tripRequest.isReturnedTrip = funcName === 'schedule'
    tripRequest.scheduledReturn = scheduledReturn
    tripRequest.returnPickupTime = returnPickupTime
  }

  dispatch(tripCreateRequest(tripRequest))
  apiFunc(tripRequest).then(
    async (tripResponse: any) => {
      //TODO: figure out why this payload has
      //so much http metadata when the others do not
      const trip: IActiveTripResponse = tripResponse.data
      if (trip.id) {
        if (tripRequest.additionalStop && tripRequest.additionalStop.length > 0) {
          dispatch(mapsActionCreators.clearMarkers('additionalStop'))
        }
        dispatch(tripCreateSuccess(trip))
        history.push(`/trips/${trip.id}`)
        if (tripRequest.product.externalUrl) {
          const loginData = getAccessJwtPayload()
          const email = loginData ? loginData.email : ''
          const url = `${tripRequest.product.externalUrl}?tripId=${trip.id}&riderEmail=${email}`
          window.open(url, '_blank')
        }
      } else if (tripResponse.data === constants.tripJustCreated) {
        dispatch(bookDoubleTrip(true)) // show message in TripServiceProductList.tsx
      }

      // CSR notification for trips that include PCA riders
      if (trip.tripsGroupRides && !!trip.tripsGroupRides.length) {
        const isRiderIncludesPCA = trip.tripsGroupRides.filter(rider => rider.riderType === 'PCA')
        if (!!isRiderIncludesPCA.length) {
          dispatch(
            createTripWithPcaRiderSuccess('Successfully created trip with PCA riders and there payment is set to free.')
          )
        }
      }
    },
    (err: string) => {
      dispatch(tripCreateFailure(err))
    }
  )
}

export const createWillCallTrip = (params?: ITripExtraParams) => (dispatch: any, getState: any) => {
  const { tripCreateRequest, tripCreateSuccess, tripCreateFailure, bookDoubleTrip } = actionCreators
  const tripRequest = getState().tripRequest.request

  const apiFunc = tripService.schedule

  // swap locations
  const temp = tripRequest.pickupLocation
  tripRequest.pickupLocation = tripRequest.dropoffLocation
  tripRequest.dropoffLocation = temp

  const zoneName = Intl.DateTimeFormat().resolvedOptions().timeZone

  let currentDate: string = ''
  if (tripRequest.scheduledPickupTime && tripRequest.scheduledPickupTime.toString().indexOf('T') > 0) {
    currentDate = tripRequest.scheduledPickupTime.toString().split('T')[0]
  } else {
    currentDate = moment
      .tz(zoneName)
      .format('YYYY-MM-DD')
      .toString()
  }
  const scheduledWillCall = moment.tz(`${currentDate} 23:59:00`, zoneName).format()

  tripRequest.scheduledPickupTime = scheduledWillCall
  tripRequest.scheduledDropoffTime = scheduledWillCall
  tripRequest.leaveAtDateTime = null
  tripRequest.arriveByDateTime = null

  tripRequest.routePolyline = getState().mapView.polyline
  tripRequest.bounds = getState().mapView.bounds
  tripRequest.tripType = 'will call'
  tripRequest.rider.countryCode = tripRequest.rider.countryCode.length > 0 ? tripRequest.rider.countryCode : '+1'
  tripRequest.rider.phoneNumber = tripRequest.rider.phoneNumber.startsWith('1')
    ? tripRequest.rider.phoneNumber.slice(1)
    : tripRequest.rider.phoneNumber

  if (params) {
    tripRequest.estimates = { ...tripRequest.estimates, price: params.addOnCost, fare: params.addOnFare }
    tripRequest.addOn = params.addOn
    tripRequest.willCall = true
  }
  if (tripRequest.destinations && !tripRequest.destinations.items) {
    tripRequest.destinations = {
      items: []
    }
  }

  dispatch(tripCreateRequest(tripRequest))
  apiFunc(tripRequest).then(
    (tripResponse: any) => {
      //TODO: figure out why this payload has
      //so much http metadata when the others do not
      const trip: IActiveTripResponse = tripResponse.data
      if (trip.id) {
        dispatch(tripCreateSuccess(trip))
        if (tripRequest.additionalStop && tripRequest.additionalStop.length > 0) {
          dispatch(mapsActionCreators.clearMarkers('additionalStop'))
        }
        history.push(`/trips/${trip.id}`)
        if (tripRequest.product.externalUrl) {
          const loginData = getAccessJwtPayload()
          const email = loginData ? loginData.email : ''
          const url = `${tripRequest.product.externalUrl}?tripId=${trip.id}&riderEmail=${email}`
          window.open(url, '_blank')
        }

        tripService.updateStatus(trip.id, 'Awaiting Will Call', TripStatuses.WILL_CALL)
      } else if (tripResponse.data === constants.tripJustCreated) {
        dispatch(bookDoubleTrip(true)) // show message in TripServiceProductList.tsx
      }
    },
    (err: string) => {
      dispatch(tripCreateFailure(err))
    }
  )
}

export const createRecurringTrip = () => (dispatch: any, getState: any) => {
  const tripRequest = getState().tripRequest.request
  tripRequest.paymentMode = getState().tripRequest.request.paymentMode
  tripRequest.routePolyline = getState().mapView.polyline
  tripRequest.bounds = getState().mapView.bounds
  tripRequest.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

  tripService
    .scheduleRecurringTrip(tripRequest)
    .then(() => {
      if (tripRequest.isUpdatedRecurringTrip === true) {
        tripService.destroyRecurringTask(tripRequest.id)
      }
      history.push(`/`)
    })
    .catch(err => {
      dispatch(actionCreators.tripCreateFailure(err))
    })
}

export const getTripById = (tripId: string) => (dispatch: any) => {
  const { tripGetRequest, tripGetSuccess, tripGetFailure } = actionCreators
  dispatch(tripGetRequest())
  const trip = tripService.get(tripId).then(
    (trip: IActiveTripResponseV2) => {
      const { destinations } = trip

      dispatch(tripGetSuccess(trip))
      dispatch(
        mapsActionCreators.setOrigin({
          lat: trip.pickupLocation.latitude,
          lng: trip.pickupLocation.longitude
        })
      )
      dispatch(
        mapsActionCreators.setDestination({
          lat: trip.dropoffLocation.latitude,
          lng: trip.dropoffLocation.longitude
        })
      )
      dispatch(
        mapsActionCreators.replaceMarkers('origin', [
          {
            type: 'origin',
            lat: trip.pickupLocation.latitude,
            lng: trip.pickupLocation.longitude
          }
        ])
      )
      dispatch(
        mapsActionCreators.replaceMarkers('destination', [
          {
            type: 'destination',
            lat: trip.dropoffLocation.latitude,
            lng: trip.dropoffLocation.longitude
          }
        ])
      )

      if (destinations && destinations.length > 0) {
        const additionalStopMarkers = destinations.map(trip => {
          const { latitude: lat, longitude: lng } = trip.location

          return {
            lat,
            lng,
            type: 'additionalStop'
          }
        })
        dispatch(mapsActionCreators.replaceMarkers('additionalStop', [...additionalStopMarkers]))
      }

      if (trip.operatorLocation) {
        const locationMarker = {
          type: 'car',
          lat: trip.operatorLocation.coordinates[1],
          lng: trip.operatorLocation.coordinates[0]
        }
        dispatch(mapsActionCreators.replaceMarkers('car', [locationMarker]))
      }
      return trip
    },
    (err: string) => dispatch(tripGetFailure(err))
  )

  return trip
}

export const cancelTrip = (tripId: string, comment: string) => async (dispatch: any) => {
  const { tripCancelRequest, tripCancelSuccess, tripCancelFailure } = actionCreators
  dispatch(tripCancelRequest())
  const oldTrip = await tripService.get(tripId)
  return tripService.updateStatus(tripId, comment, TripStatuses.CANCELLED).then(
    (response: string) => {
      if (oldTrip.operator) {
        dispatch(cancelTripPushNotification(tripId))
      }
      return dispatch(tripCancelSuccess(response))
    },
    (err: any) => {
      dispatch(tripCancelFailure(err.data))
    }
  )
}

export const getUberOperatorDriver = (tripId: string, orgID: string) => (dispatch: any) => {
  const { getUberOperatorNumberRequest, getUberOperatorNumberSuccess, getUberOperatorNumberFailure } = actionCreators
  dispatch(getUberOperatorNumberRequest())
  return tripService
    .getUberOperatorDriver(tripId, orgID)
    .then(resp => {
      dispatch(getUberOperatorNumberSuccess(resp.data))
    })
    .catch(error => {
      dispatch(getUberOperatorNumberFailure('Cannot fetch operator. Check logs for more info'))
    })
}

export const noShowTrip = (tripId: string, comment: string) => (dispatch: any) => {
  const { tripNoShowRequest, tripNoShowSuccess, tripNoShowFailure } = actionCreators
  dispatch(tripNoShowRequest())
  return tripService.updateStatus(tripId, comment, TripStatuses.NO_SHOW_RIDER).then(
    (response: string) => {
      return dispatch(tripNoShowSuccess(response))
    },
    (err: any) => {
      dispatch(tripNoShowFailure(err.data))
    }
  )
}

export const getManyStatusesById = async (tripId: string): Promise<ITripStatus[]> =>
  tripService.getManyStatusesByTripId(tripId)

export const resendTripRequest = (tripId: string) => (dispatch: any) => {
  const { tripUpdateSuccess } = actionCreators
  tripService.resendRequest(tripId).then((trip: IActiveTripResponseV2) => {
    const tripStatus = trip.lastStatus
    const stage = getStageByStatus(tripStatus)
    return dispatch(tripUpdateSuccess(trip, stage))
  })
}

export const getNearbyDrivers = (location: ICoordinates) => (dispatch: any) => {
  driversService.getNearbyDrivers(location).then((data: IPingDTO[]) => {
    const driverMarkers = data.map(d => ({ type: 'car', lat: d.location.lat, lng: d.location.lng }))
    dispatch(mapsActionCreators.replaceMarkers('car', driverMarkers))
  })
}

export const getTripDriverLocation = (tripId: string) => (dispatch: any) => {
  const { tripDriverLocationRequest, tripDriverLocationSuccess, tripDriverLocationFailure } = actionCreators

  dispatch(tripDriverLocationRequest())
  return tripService.getTripDriverLocation(tripId).then(
    (location: IOperatorLocation) => {
      dispatch(tripDriverLocationSuccess(location))
      dispatch(mapsActionCreators.setOperatorLocation(location))
    },
    (err: any) => {
      dispatch(tripDriverLocationFailure(err.data))
    }
  )
}

export const filterByZone = (payload: ITripFilters) => (dispatch: any) => {
  const { filterTripsRequest, filterTripsSuccess, filterTripsFailure } = actionCreators

  dispatch(filterTripsRequest())
  return tripService.filterByZone(payload).then(
    (trips: { items: IActiveTripResponseV2[] }) => {
      dispatch(filterTripsSuccess(trips.items))
    },
    (err: any) => {
      dispatch(filterTripsFailure(err.data))
    }
  )
}

export const assignOperator = (
  tripId: string,
  operator: ISimpleDriverDTO,
  setScheduled?: boolean,
  dispatchAssignedDriver?: boolean
) => async (dispatch: any) => {
  const { assignOperatorRequest, assignOperatorSuccess, assignOperatorFailure } = actionCreators

  dispatch(assignOperatorRequest())
  const oldTrip = await tripService.get(tripId)
  return tripService.assignOperator(tripId, operator, setScheduled, dispatchAssignedDriver).then(
    async (data: {
      tripsGroupRides: ITripGroupRides[]
      product: ISimpleProviderProduct
      trip: IActiveTripResponseV2
    }) => {
      dispatch(assignOperatorSuccess(data.trip))
      dispatch(getTripById(tripId))

      if (
        (oldTrip && oldTrip.operator && oldTrip.operator.id && oldTrip.operator.operatorId !== operator.operatorId) ||
        (oldTrip && oldTrip.operator === null && operator.operatorId)
      ) {
        dispatch(updateTripOperatorPushNotification(tripId))
      }

      const { allottedTimeAtDropoff = 0, allottedTimeAtPickup = 0 } = data.product || {}
      dispatch(allottedTimePushNotifcation(tripId, { allottedTimeAtDropoff, allottedTimeAtPickup }))

      const isRiderIncludesPCA = data.tripsGroupRides.filter(rider => rider.riderType === 'PCA')
      if (!!isRiderIncludesPCA.length) {
        const { operatorId } = operator
        dispatch(
          sendPushNotificationToDriver({
            operatorId,
            title: `GOIN' Updates`,
            body: 'PCA rider is included, and no payment is required.'
          })
        )
      }

      return data.trip
    },
    (err: any) => {
      dispatch(assignOperatorFailure(err.data))
      return err
    }
  )
}

export const assignMultipleOperator = (tripIds: string[], operator: ISimpleDriverDTO) => (dispatch: any) => {
  const { assignMultipleOperatorRequest, assignMultipleOperatorSuccess, assignMultipleOperatorFailure } = actionCreators

  dispatch(assignMultipleOperatorRequest())
  return tripService.assignMultipleOperator(tripIds, operator).then(
    (data: { trip: IActiveTripResponseV2 }) => {
      dispatch(assignMultipleOperatorSuccess(data.trip))
      return data.trip
    },
    (err: any) => {
      dispatch(assignMultipleOperatorFailure(err.data))
      return err
    }
  )
}

export const cancelMultipleOperator = (tripIds: string[], comment: string) => (dispatch: any) => {
  const { cancelMultipleOperatorRequest, cancelMultipleOperatorSuccess, cancelMultipleOperatorFailure } = actionCreators

  dispatch(cancelMultipleOperatorRequest())
  return tripService.cancelMultipleOperator(tripIds, comment, TripStatuses.CANCELLED).then(
    (data: { trip: IActiveTripResponseV2 }) => {
      dispatch(cancelMultipleOperatorSuccess(data.trip))
      return data
    },
    (err: any) => {
      dispatch(cancelMultipleOperatorFailure(err.data))
      return err
    }
  )
}

export const manualCompleteTrip = (tripIds: string[], comment: string, data: IManualCompleteTripState) => (
  dispatch: any
) => {
  const { manualCompleteTripRequest, manualCompleteTripSuccess, manualCompleteTripFailure } = actionCreators

  dispatch(manualCompleteTripRequest())
  return tripService.manualCompleteTrip(tripIds, comment, TripStatuses.MANUALLY_COMPLETED, data).then(
    (data: { trip: IActiveTripResponseV2 }) => {
      dispatch(manualCompleteTripSuccess(data.trip))
      return data
    },
    (err: any) => {
      dispatch(manualCompleteTripFailure(err.data))
      return err
    }
  )
}

export const completeTripManually = (
  tripId: string,
  paymentRequired: boolean,
  tripPrice?: number,
  comment?: string,
  disableNotification?: boolean
) => (dispatch: any) => {
  const { completeTripManuallyRequest, completeTripManuallylSuccess, completeTripManuallyFailure } = actionCreators
  dispatch(completeTripManuallyRequest())
  return tripService.completeManually(tripId, paymentRequired, tripPrice, comment, disableNotification).then(
    (tripId: string) => {
      dispatch(completeTripManuallylSuccess(tripId))
      history.push(`/trips/${tripId}`)
      window.location.reload()
    },
    ({ data }) => {
      dispatch(completeTripManuallyFailure(data))
      setTimeout(() => {
        dispatch(completeTripManuallyFailure(''))
      }, 5000)
    }
  )
}

export const cancelBillable = (
  tripId: string,
  paymentRequired: boolean,
  tripPrice?: number,
  comment?: string,
  disableNotification?: boolean
) => async (dispatch: any) => {
  const {
    cancelBillableManuallyRequest,
    cancelBillableManuallylSuccess,
    cancelBillableManuallyFailure
  } = actionCreators
  dispatch(cancelBillableManuallyRequest())
  const oldTrip = await tripService.get(tripId)
  return tripService.cancelBillable(tripId, paymentRequired, tripPrice, comment, disableNotification).then(
    (tripId: string) => {
      if (oldTrip.operator) {
        dispatch(cancelTripPushNotification(tripId))
      }
      dispatch(cancelBillableManuallylSuccess(tripId))
      history.push(`/trips/${tripId}`)
      window.location.reload()
    },
    ({ data }) => {
      dispatch(cancelBillableManuallyFailure(data))
      setTimeout(() => {
        dispatch(cancelBillableManuallyFailure(''))
      }, 5000)
    }
  )
}

export function sendPushNotificationToDriver({
  operatorId,
  title,
  body
}: {
  operatorId: string
  title: string
  body: string
}) {
  const { driverPushNotificationSuccess, driverPushNotificationFailure } = actionCreators
  const payload = {
    notification: {
      title,
      body
    },
    data: {
      extraInfo: null,
      operatorId
    }
  }

  return (dispatch: any) => {
    driversService
      .sendPushNotificationToDriver(payload)
      .then(() => dispatch(driverPushNotificationSuccess('Operator successfully notified about PCA rider.')))
      .catch(() => dispatch(driverPushNotificationFailure('Error sending notification to operator.')))
  }
}

export const updateTripNotesPushNotification = (tripIdParam: string, params: ITripEdit) => (dispatch: any) => {
  const { tripNotesPushNotifRequest, tripNotesPushNotifSuccess, tripNotesPushNotifFail } = actionCreators
  const { notes } = params
  const validateNotesValue = (note: string | undefined) => {
    return note !== ';' && note !== undefined ? note : '_'
  }
  const payload = {
    notification: {
      title: "GOIN' Updates",
      body: `Notes updated: ${validateNotesValue(notes)}`
    },
    data: {
      extraInfo: null,
      tripId: tripIdParam
    }
  }
  dispatch(tripNotesPushNotifRequest())
  return tripService
    .updateTripPushNotification(payload)
    .then(() =>
      dispatch(tripNotesPushNotifSuccess('Trip notes updated, notification will be sent to assigned operator.'))
    )
    .catch(() => dispatch(tripNotesPushNotifFail('Sending push notification failed.')))
}

export const updateTripTimePushNotification = (tripIdParam: string, params: ITripEdit) => (dispatch: any) => {
  const { tripTimePushNotifRequest, tripTimePushNotifSuccess, tripTimePushNotifFail } = actionCreators
  const { scheduledPickupTime, prevScheduledPickupTime } = params

  const payload = {
    notification: {
      title: `GOIN' Updates`,
      body: `Scheduled Pickup Trip time has been updated to ${moment(scheduledPickupTime).format('MMMM Do, h:mm a')}.`
    },
    data: {
      extraInfo: null,
      tripId: tripIdParam
    }
  }

  dispatch(tripTimePushNotifRequest())
  return tripService
    .updateTripPushNotification(payload)
    .then(() =>
      dispatch(tripTimePushNotifSuccess('Trip time updated, notification will be sent to assigned operator.'))
    )
    .catch(() => dispatch(tripTimePushNotifFail('Sending push notification failed.')))
}

export const updateTripOperatorPushNotification = (tripIdParam: string) => (dispatch: any) => {
  const { tripOperatorPushNotifRequest, tripOperatorPushNotifSuccess, tripOperatorPushNotifFail } = actionCreators

  const payload = {
    notification: {
      title: `GOIN' Updates`,
      body: `A trip has been assigned to you.`
    },
    data: {
      extraInfo: null,
      tripId: tripIdParam
    }
  }

  dispatch(tripOperatorPushNotifRequest())
  return tripService
    .updateTripPushNotification(payload)
    .then(() =>
      dispatch(tripOperatorPushNotifSuccess('Trip operator updated, notification will be sent to assigned operator.'))
    )
    .catch(() => dispatch(tripOperatorPushNotifFail('Sending push notification failed.')))
}

export const cancelTripPushNotification = (tripIdParam: string) => (dispatch: any) => {
  const { tripCancelPushNotifRequest, tripCancelPushNotifSuccess, tripCancelPushNotifFail } = actionCreators

  const payload = {
    notification: {
      title: `GOIN' Updates`,
      body: `A trip has been cancelled.`
    },
    data: {
      extraInfo: null,
      tripId: tripIdParam
    }
  }

  dispatch(tripCancelPushNotifRequest())
  return tripService
    .updateTripPushNotification(payload)
    .then(() => dispatch(tripCancelPushNotifSuccess('Trip cancelled, notification will be sent to assigned operator.')))
    .catch(() => dispatch(tripCancelPushNotifFail('Sending push notification failed.')))
}

export const allottedTimePushNotifcation = (
  tripId: string,
  timeDetails: { allottedTimeAtDropoff: number; allottedTimeAtPickup: number }
) => (dispatch: any) => {
  const { allottedTimePushNotifRequest, allottedTimePushNotifSuccess, allottedTimePushNotifFail } = actionCreators
  const { allottedTimeAtDropoff, allottedTimeAtPickup } = timeDetails

  const payload = {
    notification: {
      title: `GOIN' Updates`,
      body: `Allotted Time at Pickup: ${allottedTimeAtPickup} ${
        allottedTimeAtPickup <= 1 ? 'min.' : 'mins.'
      }, Allotted Time at Drop-Off: ${allottedTimeAtDropoff} ${allottedTimeAtDropoff <= 1 ? 'min.' : 'mins.'}`
    },
    data: {
      extraInfo: null,
      tripId
    }
  }

  dispatch(allottedTimePushNotifRequest())
  return tripService
    .updateTripPushNotification(payload)
    .then(() => dispatch(allottedTimePushNotifSuccess('Success: Allotted time details successfully sent.')))
    .catch(() => dispatch(allottedTimePushNotifFail('Error: Sending allotted time push notification failed.')))
}

export const saveData = (params: ITripEdit) => (dispatch: any, getState: any) => {
  const tripId = getState().trips.currentTripId
  const { notes, prevNotes, scheduledPickupTime, prevScheduledPickupTime, tripAction } = params
  let tripIdParam = tripId
  const { saveDataRequest, saveDataSuccess, saveDataFailure } = actionCreators

  if (!tripId) {
    if (params.tripId !== null && params.tripId !== undefined && params.tripId !== '') {
      tripIdParam = params.tripId
    } else {
      return
    }
  }

  dispatch(saveDataRequest())
  return tripService.saveData(tripIdParam, params).then(
    trip => {
      dispatch(saveDataSuccess())
      dispatch(getTripById(tripIdParam))

      const filterNoteValue = (note: string | undefined) => {
        if (note !== undefined) {
          const filteredNotes = note.replace(/[ ;]/g, '')
          return filteredNotes
        }
        return ''
      }

      const validateNotes = () => {
        if (notes !== undefined) {
          const filterCurrentNotes = filterNoteValue(notes)
          const filterPreviousNotes = filterNoteValue(prevNotes)
          return filterCurrentNotes !== filterPreviousNotes
        }
        return false
      }

      // Trigger push notification when trip notes is updated
      if (validateNotes() && tripAction === 'EDIT_TRIP_DETAILS') {
        dispatch(updateTripNotesPushNotification(tripIdParam, params))
      }

      // Trigger push notification when trip time is updated
      if (scheduledPickupTime !== prevScheduledPickupTime) {
        dispatch(updateTripTimePushNotification(tripIdParam, params))
      }
    },
    ({ data }) => {
      dispatch(saveDataFailure(data))
    }
  )
}

export const savePolylineBounds = () => (dispatch: any, getState: any) => {
  const tripId = getState().trips.currentTripId
  const polyline = getState().mapView.polyline
  const bounds = getState().mapView.bounds
  const { savePolylineBoundsRequest, savePolylineBoundsSuccess, savePolylineBoundsFailure } = actionCreators
  if (!tripId) {
    return
  }
  dispatch(savePolylineBoundsRequest())
  return tripService.savePolylineBounds(tripId, polyline, bounds).then(
    trip => {
      dispatch(savePolylineBoundsSuccess())
    },
    ({ data }) => {
      dispatch(savePolylineBoundsFailure(data))
    }
  )
}

export const updateFeedbackStatus = (tripId: string, feedbackStatus: string, prevFeedbackStatus: string) => (
  dispatch: any,
  getState: any
) => {
  const { updateFeedbackStatusRequest, updateFeedbackStatusSuccess, updateFeedbackStatusFailure } = actionCreators
  dispatch(updateFeedbackStatusRequest())

  return tripService
    .updateFeedbackStatus(tripId, feedbackStatus, prevFeedbackStatus)
    .then(data => dispatch(updateFeedbackStatusSuccess(data)))
    .catch(err => dispatch(updateFeedbackStatusFailure(err.statusText)))
}

export const getDailyTripLog = (params: IDailyTripLogReq) => (dispatch: any, getState: any) => {
  const { getDailyTripLogRequest, getDailyTripLogSuccess, getDailyTripLogFailire } = actionCreators
  dispatch(getDailyTripLogRequest())
  return tripService
    .getDailyTripLog(params)
    .then(res => {
      dispatch(getDailyTripLogSuccess(res.data))
    })
    .catch(err => dispatch(getDailyTripLogFailire(err.statusText)))
}

export const getTripLogPerServiceAndDateRange = (params: ITripLogReq) => (dispatch: any, getState: any) => {
  const {
    getTripLogPerServiceAndDateRangeRequest,
    getTripLogPerServiceAndDateRangeSuccess,
    getTripLogPerServiceAndDateRangeFailure
  } = actionCreators
  dispatch(getTripLogPerServiceAndDateRangeRequest())
  return tripService
    .getTripLogPerServiceAndDateRange(params)
    .then(res => {
      dispatch(getTripLogPerServiceAndDateRangeSuccess(res.data))
    })
    .catch(err => dispatch(getTripLogPerServiceAndDateRangeFailure(err.statusText)))
}

export const getTripStatusesCount = (params: ICountTripStatusFilter) => (dispatch: any, getState: any) => {
  const { getTripStatusesCountRequest, getTripStatusesCountSuccess, getTripStatusesCountFailure } = actionCreators
  dispatch(getTripStatusesCountRequest)
  return tripService
    .getTripStatusesCount(params)
    .then(res => {
      dispatch(getTripStatusesCountSuccess(res.data))
    })
    .catch(error => {
      dispatch(getTripStatusesCountFailure(error.statusText))
    })
}

export const getTotalTripsPerService = (orgId: string, params: IServiceListFilterDTO) => (
  dispatch: any,
  getState: any
) => {
  const {
    getTotalTripsPerServiceRequest,
    getTotalTripsPerServiceSuccess,
    getTotalTripsPerServiceFailure
  } = actionCreators
  dispatch(getTotalTripsPerServiceRequest())
  return tripService
    .fetchTotalTripsPerService(orgId, params)
    .then(res => {
      dispatch(getTotalTripsPerServiceSuccess(res.data))
      return res
    })
    .catch(err => dispatch(getTotalTripsPerServiceFailure(err.statusText)))
}
//Weather
export const getWeatherUpdate = (orgId: string, params: WeatherQueryParams) => (dispatch: any) => {
  const { getWeatherUpdatesRequest, getWeatherUpdatesSuccess } = actionCreators
  // dispatch(getWeatherUpdatesRequest())
  console.log('WEATHER UPDATE CALLED')
  return tripService
    .getWeather(orgId, params)
    .then(res => {
      dispatch(actionCreators.getWeatherUpdatesSuccess(res.data))
    })
    .catch(res => {
      dispatch(actionCreators.getWeatherUpdatesFail(res.data))
    })
}
// 140d1fb6-da24-43fa-971f-730d92b49570?date=2022-09-26&address=Seattle, WA, US

export const optimizeRoute = (request: IScheduledRequestedTripsFiltersDTO) => (dispatch: any) => {
  const { routeOptimizeRequest, routeOptimizeSuccess, routeOptimizeFailure } = actionCreators
  dispatch(routeOptimizeRequest())

  return tripService
    .routeOptimization(request)
    .then(({ data }) => {
      if (!data.success) {
        dispatch(routeOptimizeFailure(data))
        return data
      }
      dispatch(routeOptimizeSuccess(data))
      return data
    })
    .catch(error => dispatch(routeOptimizeFailure(error.data)))
}

export const optimizeTrip = (request: IUpdateOptimizedTripsDTO) => (dispatch: any) => {
  const { optimizeTripRequest, optimizeTripSuccess, optimizeTripFailure } = actionCreators
  dispatch(optimizeTripRequest())
  return tripService
    .optimizeTrip(request)
    .then(({ data }) => {
      if (!data.success) {
        dispatch(optimizeTripFailure(data))
        return data
      }
      dispatch(optimizeTripSuccess(data))
      return data
    })
    .catch(error => dispatch(optimizeTripFailure(error.data)))
}

export const groupRideRequestedScheduledTrips = (param: ITripFilters) => (dispatch: any, getState: any) => {
  const {
    groupRequestedScheduledTripsRequest,
    groupRequestedScheduledTripsSuccess,
    groupRequestedScheduledTripsFailure
  } = actionCreators
  dispatch(groupRequestedScheduledTripsRequest)
  return tripService
    .groupRequestedScheduledTrips(param)
    .then(res => {
      dispatch(groupRequestedScheduledTripsSuccess(res.data.message))
    })
    .catch(error => {
      const { statusText, data: errMessage } = error || ''
      const err = statusText ? statusText : errMessage
      dispatch(groupRequestedScheduledTripsFailure(err))
    })
}

export const unGroupRideRequestedScheduledTrips = (param: ITripFilters) => (dispatch: any) => {
  const {
    unGroupRequestedScheduledTripsRequest,
    unGroupRequestedScheduledTripsSuccess,
    unGroupRequestedScheduledTripsFailure
  } = actionCreators
  dispatch(unGroupRequestedScheduledTripsRequest)
  return tripService
    .unGroupRequestedScheduledTrips(param)
    .then(res => {
      const {
        data: { totalTrips },
        success
      } = res.data || null
      if (success) {
        dispatch(unGroupRequestedScheduledTripsSuccess(`Successfully ungroup ${totalTrips} trip(s).`))
        return
      }
      dispatch(unGroupRequestedScheduledTripsFailure('Ungrouping of trips unsuccessfull.'))
    })
    .catch(error => {
      const { statusText, data: errMessage } = error || 'Ungrouping of trips unsuccessfull.'
      const err = statusText ? statusText : errMessage
      dispatch(unGroupRequestedScheduledTripsFailure(err))
    })
}

export const manual = (request: ManualTripGroupRidesDTO) => (dispatch: any) => {
  const { manualGroupTripsRequest, manualGroupTripsSuccess, manualGroupTripsFailure } = actionCreators
  dispatch(manualGroupTripsRequest())
  return tripService
    .manual(request)
    .then(({ data }) => {
      if (!data.success) {
        dispatch(manualGroupTripsFailure(data.message))
        return data
      }
      dispatch(manualGroupTripsSuccess(data))
      return data
    })
    .catch(error => dispatch(manualGroupTripsFailure(error.data)))
}

export function getTemporaryVehicles() {
  const { getTemporaryVehiclesRequest, getTemporaryVehiclesSuccess, getTemporaryVehiclesFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(getTemporaryVehiclesRequest())
    tripService.getAllTemporaryVehicles().then(
      ({ data }) => {
        dispatch(getTemporaryVehiclesSuccess(data.data))
      },
      (error: string) => dispatch(getTemporaryVehiclesFailure(error))
    )
  }
}

export function getTemporaryVehicleTripsCount(serviceId: string) {
  const {
    getTempVehicleTripsCountRequest,
    getTempVehicleTripsCountSuccess,
    getTempVehicleTripsCountFailure
  } = actionCreators
  return (dispatch: any) => {
    dispatch(getTempVehicleTripsCountRequest())
    tripService.getTemporaryVehicleTripsCount(serviceId).then(
      ({ data }) => {
        dispatch(getTempVehicleTripsCountSuccess(data))
      },
      error => {
        const { statusText, data: errMessage } = error || ''
        const err = typeof errMessage === 'string' ? errMessage : statusText
        dispatch(getTempVehicleTripsCountFailure(`Temporary Vehicle Count: ${err}`))
      }
    )
  }
}

export function getScheduledRequestedTrips(params: IScheduledRequestedTripsFiltersDTO) {
  const {
    getScheduledRequestedTripsRequest,
    getScheduledRequestedTripsSuccess,
    getScheduledRequestedTripsFailure
  } = actionCreators
  return (dispatch: any) => {
    dispatch(getScheduledRequestedTripsRequest())
    return tripService.getScheduledRequestedTrips(params).then(
      res => {
        dispatch(getScheduledRequestedTripsSuccess(res))
        console.log(res)
        return res.data
      },
      error => {
        const { statusText, data: errMessage } = error || ''
        const err = typeof errMessage === 'string' ? errMessage : statusText
        dispatch(getScheduledRequestedTripsFailure(`Get scheduled requested trips error: ${err}`))
      }
    )
  }
}

export function getTempVehicleByServiceCount() {
  const {
    getTempVehicleByServiceCountRequest,
    getTempVehicleByServiceCountSuccess,
    getTempVehicleByServiceCountFailure
  } = actionCreators
  return (dispatch: any) => {
    dispatch(getTempVehicleByServiceCountRequest())
    tripService.fetchTempVehicleByServiceCount().then(
      ({ data }) => {
        dispatch(getTempVehicleByServiceCountSuccess(data))
      },
      (error: string) => dispatch(getTempVehicleByServiceCountFailure(error))
    )
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/trips/index.ts